import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 256 256"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("desc", null, "Dots Three Vertical Bold Streamline Icon: https://streamlinehq.com", -1),
    _createElementVNode("path", { d: "M104.107 26.453c0-18.393 19.91-29.888 35.84-20.692 15.929 9.197 15.929 32.188 0 41.385a23.9 23.9 0 0 1-11.947 3.2c-13.196.001-23.893-10.696-23.893-23.893M128 104.107c-18.393-.001-29.889 19.91-20.693 35.839s32.187 15.93 41.385.002A23.9 23.9 0 0 0 151.893 128c0-13.195-10.697-23.893-23.893-23.893m0 101.546c-18.393 0-29.889 19.91-20.693 35.84 9.196 15.929 32.187 15.93 41.385.001a23.9 23.9 0 0 0 3.201-11.947c0-13.196-10.697-23.893-23.893-23.894" }, null, -1)
  ]))]))
}
export default { render: render }